import { render, staticRenderFns } from "./WorkGroupDetail.vue?vue&type=template&id=50bb1964"
import script from "./WorkGroupDetail.vue?vue&type=script&lang=js"
export * from "./WorkGroupDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports